import { render, staticRenderFns } from "./VerificationNotification.vue?vue&type=template&id=3d555de6&scoped=true"
import script from "./VerificationNotification.vue?vue&type=script&lang=js"
export * from "./VerificationNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d555de6",
  null
  
)

export default component.exports